import React, { useEffect, useState } from 'react'
import Hero from '../Components/Hero/Hero'
import FeatureBar from '../Components/FeatureBar/FeatureBar'
import CategoryBanners from '../Components/CategoryBanners/CategoryBanners'
import Popular from '../Components/Popular/Popular'
import Offers from '../Components/Offers/Offers'
import NewCollections from '../Components/NewCollections/NewCollections'
import BrandsMarquee from '../Components/BrandsMarquee/BrandsMarquee'
import Testimonials from '../Components/Testimonials/Testimonials'
import NewsLetter from '../Components/NewsLetter/NewsLetter'
import AllProducts from '../Components/AllProducts/AllProducts'
import AdBanner from '../Components/AdBanner/AdBanner'
import { backend_url } from '../App'

const DEFAULT_BANNERS = [
  { image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=1400&h=350&fit=crop", title: "Premium Gaming Setup",        subtitle: "Experience next-level gaming with our curated gaming gear collection. Up to 40% off.",       ctaText: "Explore Gaming",    ctaLink: "/gaming",      accent: "#00d4ff", active: true },
  { image: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?w=1400&h=350&fit=crop", title: "Smart Watch Collection",      subtitle: "Stay connected with the latest smartwatch technology. Free shipping on all orders.",         ctaText: "Shop Now",          ctaLink: "/accessories", accent: "#7c3aed", active: true },
  { image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1400&h=350&fit=crop", title: "Wireless Earbuds Deal",        subtitle: "Crystal clear audio. Exceptional battery life. Limited time offer — 35% off.",              ctaText: "View Deal",         ctaLink: "/accessories", accent: "#f59e0b", active: true },
  { image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=1400&h=350&fit=crop", title: "Laptop Megasale",              subtitle: "Powerful processors. Stunning displays. Best prices guaranteed. Shop the sale.",              ctaText: "Browse Laptops",    ctaLink: "/laptops",     accent: "#22c55e", active: true },
  { image: "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=1400&h=350&fit=crop", title: "Camera & Photography",         subtitle: "Capture life in stunning detail. Professional-grade cameras and lenses.",                    ctaText: "Discover More",     ctaLink: "/accessories", accent: "#ec4899", active: true },
  { image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1400&h=350&fit=crop", title: "Tech Accessories Bundle",      subtitle: "Cables, adapters, chargers — everything you need. Buy 2, get 1 free.",                      ctaText: "Shop Bundles",      ctaLink: "/accessories", accent: "#06b6d4", active: true },
  { image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=1400&h=350&fit=crop", title: "Exclusive Member Benefits",    subtitle: "Sign up today and unlock exclusive deals, early access, and loyalty rewards.",               ctaText: "Join Now",          ctaLink: "/membership",  accent: "#f97316", active: true },
  { image: "https://images.unsplash.com/photo-1522869635100-ce306f08dc64?w=1400&h=350&fit=crop", title: "Trade-In Program",             subtitle: "Upgrade your old device. Get instant cash or store credit. Hassle-free process.",            ctaText: "Start Trade-In",    ctaLink: "/trade-in",    accent: "#8b5cf6", active: true },
  { image: "https://images.unsplash.com/photo-1550355291-bbee04a92027?w=1400&h=350&fit=crop", title: "Complete Tech Marketplace",    subtitle: "Explore thousands of products from top brands. Quality guaranteed. Fast delivery.",          ctaText: "Start Shopping",    ctaLink: "/shop",        accent: "#00d4ff", active: true },
  { image: "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=1400&h=350&fit=crop", title: "Still Looking? We Have More", subtitle: "Browse thousands of verified products. Free shipping on orders above Rs. 2,000.",            ctaText: "Continue Shopping", ctaLink: "/shop",        accent: "#7c3aed", active: true },
];

const Shop = () => {

  const [popular, setPopular] = useState([]);
  const [newcollection, setNewCollection] = useState([]);
  const [banners, setBanners] = useState(DEFAULT_BANNERS);

  const fetchInfo = () => {
    fetch(`${backend_url}/popularinwomen`)
            .then((res) => res.json()) 
            .then((data) => setPopular(data))
    fetch(`${backend_url}/newcollections`)
            .then((res) => res.json()) 
            .then((data) => setNewCollection(data))
    fetch(`${backend_url}/homecontent`)
            .then((res) => res.json())
            .then((data) => { if (data.adBanners?.length) setBanners(data.adBanners); })
            .catch(() => {})
    }

    useEffect(() => {
      fetchInfo();
    }, [])


  return (
    <div className="bg-[#060c18] min-h-screen">
      {/* 1. Hero Slider */}
      <Hero/>

      {/* Ad Banner 1 */}
      {banners[0] && banners[0].active !== false && <AdBanner {...banners[0]} />}

      {/* 2. Trust/Feature Bar */}
      <FeatureBar/>

      {/* Ad Banner 2 */}
      {banners[1] && banners[1].active !== false && <AdBanner {...banners[1]} />}

      {/* 3. Category Banners */}
      <CategoryBanners/>

      {/* Ad Banner 3 */}
      {banners[2] && banners[2].active !== false && <AdBanner {...banners[2]} />}

      {/* 4. Trending / Popular Products */}
      <Popular data={popular}/>

      {/* Ad Banner 4 */}
      {banners[3] && banners[3].active !== false && <AdBanner {...banners[3]} />}

      {/* 5. Flash Sale + Promo Strips */}
      <Offers/>

      {/* Ad Banner 5 */}
      {banners[4] && banners[4].active !== false && <AdBanner {...banners[4]} />}

      {/* 6. New Arrivals */}
      <NewCollections data={newcollection}/>

      {/* Ad Banner 6 */}
      {banners[5] && banners[5].active !== false && <AdBanner {...banners[5]} />}

      {/* 7. Trusted Brands */}
      <BrandsMarquee/>

      {/* Ad Banner 7 */}
      {banners[6] && banners[6].active !== false && <AdBanner {...banners[6]} />}

      {/* 8. Customer Testimonials */}
      <Testimonials/>

      {/* Ad Banner 8 */}
      {banners[7] && banners[7].active !== false && <AdBanner {...banners[7]} />}

      {/* 9. Newsletter */}
      <NewsLetter/>

      {/* Ad Banner 9 */}
      {banners[8] && banners[8].active !== false && <AdBanner {...banners[8]} />}

      {/* 10. All Products Catalog */}
      <AllProducts/>

      {/* Ad Banner 10 - Closing CTA */}
      {banners[9] && banners[9].active !== false && <AdBanner {...banners[9]} />}
    </div>
  )
}

export default Shop
